// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_user_binding_reasons.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.GrantReason
 */
export interface GrantReason {
    /**
     * The ID of the app that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * This is one part of the derived ID, indicating the type, like "ticket" or "group"
     *
     * @generated from protobuf field: string derived_id_type = 4
     */
    derivedIdType: string;
    /**
     * This is the other part of the derived ID which include the details like ticket_id, group_id, etc. This provides the uniqueness.
     *
     * @generated from protobuf field: string derived_id_data = 5
     */
    derivedIdData: string;
    /**
     * GrantReasonReferenceStrength is used to indicate the strength of the reference to the reason.
     * This is used to determine if a grant should be removed when all strong reasons are removed.
     *
     * @generated from protobuf field: c1.api.app.v1.GrantReasonReferenceStrength reference_strength = 7
     */
    referenceStrength: GrantReasonReferenceStrength;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 10
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason will expire. After this timestamp it's no longer valid.
     *
     * @generated from protobuf field: google.protobuf.Timestamp reason_expires_at = 11
     */
    reasonExpiresAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantReasonWaitingForAppUser
 */
export interface GrantReasonWaitingForAppUser {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: string ticket_id = 3
     */
    ticketId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantReason reason_needs_app_user = 4
     */
    reasonNeedsAppUser?: GrantReason;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.app.v1.GrantReasonReferenceStrength
 */
export enum GrantReasonReferenceStrength {
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_WEAK = 1;
     */
    WEAK = 1,
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_STRONG = 2;
     */
    STRONG = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GrantReason$Type extends MessageType<GrantReason> {
    constructor() {
        super("c1.api.app.v1.GrantReason", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "derived_id_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "derived_id_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "reference_strength", kind: "enum", T: () => ["c1.api.app.v1.GrantReasonReferenceStrength", GrantReasonReferenceStrength, "GRANT_REASON_REFERENCE_STRENGTH_"] },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "reason_expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<GrantReason>): GrantReason {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.derivedIdType = "";
        message.derivedIdData = "";
        message.referenceStrength = 0;
        if (value !== undefined)
            reflectionMergePartial<GrantReason>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantReason): GrantReason {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string derived_id_type */ 4:
                    message.derivedIdType = reader.string();
                    break;
                case /* string derived_id_data */ 5:
                    message.derivedIdData = reader.string();
                    break;
                case /* c1.api.app.v1.GrantReasonReferenceStrength reference_strength */ 7:
                    message.referenceStrength = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 10:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp reason_expires_at */ 11:
                    message.reasonExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.reasonExpiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantReason, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string derived_id_type = 4; */
        if (message.derivedIdType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.derivedIdType);
        /* string derived_id_data = 5; */
        if (message.derivedIdData !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.derivedIdData);
        /* c1.api.app.v1.GrantReasonReferenceStrength reference_strength = 7; */
        if (message.referenceStrength !== 0)
            writer.tag(7, WireType.Varint).int32(message.referenceStrength);
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 10; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp reason_expires_at = 11; */
        if (message.reasonExpiresAt)
            Timestamp.internalBinaryWrite(message.reasonExpiresAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantReason
 */
export const GrantReason = new GrantReason$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantReasonWaitingForAppUser$Type extends MessageType<GrantReasonWaitingForAppUser> {
    constructor() {
        super("c1.api.app.v1.GrantReasonWaitingForAppUser", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason_needs_app_user", kind: "message", T: () => GrantReason },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<GrantReasonWaitingForAppUser>): GrantReasonWaitingForAppUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.userId = "";
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<GrantReasonWaitingForAppUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantReasonWaitingForAppUser): GrantReasonWaitingForAppUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* string ticket_id */ 3:
                    message.ticketId = reader.string();
                    break;
                case /* c1.api.app.v1.GrantReason reason_needs_app_user */ 4:
                    message.reasonNeedsAppUser = GrantReason.internalBinaryRead(reader, reader.uint32(), options, message.reasonNeedsAppUser);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantReasonWaitingForAppUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string ticket_id = 3; */
        if (message.ticketId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ticketId);
        /* c1.api.app.v1.GrantReason reason_needs_app_user = 4; */
        if (message.reasonNeedsAppUser)
            GrantReason.internalBinaryWrite(message.reasonNeedsAppUser, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantReasonWaitingForAppUser
 */
export const GrantReasonWaitingForAppUser = new GrantReasonWaitingForAppUser$Type();
